import React from "react";
import "./MisMedicos.css";

const MisMedicosTituloTxt = () => {
    return (
        <React.Fragment>
            <div className="ptur-misMedicos-textoInicial">
                <p className="rb24b">Buscá y calificá tus médicos especialistas</p>
                <p className="rb18l">Calificando nuestros profesionales podemos mejorar nuestro servicios</p>
            </div>
        </React.Fragment>
    );
}
 
export default MisMedicosTituloTxt;